import React, { useEffect, useState } from "react";

import { fetchUserPermissions } from "@api";
import { useOrg } from "@hooks/useOrg";
import { useUser } from "@hooks/useUser";
import { loadPermissions, Permission } from "@types";
import { withToaster } from "@utils/util";

interface IPermissionsContext {
  permissions: Permission[];
}

export const PermissionsContext = React.createContext<IPermissionsContext>({
  permissions: [],
});

interface PermissionsProviderProps {
  permissionsLoaded: boolean;
  setPermissionsLoaded: (loaded: boolean) => void;
}
export const PermissionsProvider: React.FC<PermissionsProviderProps> = ({
  permissionsLoaded,
  setPermissionsLoaded,
  children,
}) => {
  const [permissions, setPermissions] = useState<Permission[]>([]);
  const org = useOrg();
  const user = useUser();

  useEffect(() => {
    // Load permissions every time org or user is changed
    if (!user || !org || permissionsLoaded) return;
    withToaster(
      () =>
        fetchUserPermissions(org.id)
          .then((response) =>
            setPermissions(loadPermissions(response.authorized_actions))
          )
          .finally(() => setPermissionsLoaded(true)),
      (err) =>
        `Error loading permissions for deployment '${org.id}': ${err.message}`
    )();
  }, [org, user, permissionsLoaded, setPermissionsLoaded]);
  return (
    <PermissionsContext.Provider value={{ permissions }}>
      {children}
    </PermissionsContext.Provider>
  );
};
